import {useMutation} from "@apollo/client";
import {AddEventDocument, AddEventMutation, AddEventMutationVariables} from "generated/graphql";

export const useAddEvent = () =>
  useMutation<AddEventMutation, AddEventMutationVariables>(AddEventDocument);